import { useEffect, useState } from 'react';
import type { GridSettingsStore } from '../../store';

/**
 * Hook do zarządzania hydratacją store z obsługą localStorage i async storage
 */
type PersistApi = {
  hasHydrated?: () => boolean;
  onFinishHydration?: (cb: () => void) => (() => void) | void;
};

type MaybePersisted = {
  persist?: PersistApi;
};

export const useStoreHydration = (store: GridSettingsStore & MaybePersisted, usesAsyncStorage?: boolean) => {
  const initialHydrated = !!usesAsyncStorage || !store.persist || !!store.persist.hasHydrated?.();

  const [isHydrated, setIsHydrated] = useState<boolean>(initialHydrated);

  useEffect(() => {
    if (usesAsyncStorage || !store.persist) {
      return;
    }
    if (store.persist.hasHydrated?.()) {
      return;
    }

    const unsubscribe = store.persist.onFinishHydration?.(() => {
      setIsHydrated(true);
    });

    return unsubscribe as (() => void) | undefined;
  }, [store, usesAsyncStorage]);

  return isHydrated;
};
